import React, { useState, useEffect, useCallback } from 'react';
import { API, C, authHeaders, ago, when, btn, btnMain, inp, Flag, LevelBadge, StatusDot } from './modApi';

function IntroPanel({ modId, meProfile, onClose }) {
  const [d, setD] = useState(null);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    fetch(API + '/mods/' + modId + '/intro/', { headers: authHeaders() })
      .then(function (r) { return r.json(); })
      .then(function (j) { setD(j); setText((j.mod && j.mod.introduction) || ''); })
      .catch(function () {});
  }, [modId]);
  useEffect(function () { load(); }, [load]);

  if (!d || d.error) {
    return <p style={{ fontSize: 12, color: C.muted, padding: '1rem 0' }}>{d ? d.error : 'Loading...'}</p>;
  }

  const isMe = meProfile && meProfile.id === d.mod.id;

  const saveIntro = async function () {
    setBusy(true);
    try {
      const res = await fetch(API + '/mods/' + modId + '/intro/', {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({ introduction: text }),
      });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      load();
    } catch (e) { alert(e.message); }
    setBusy(false);
  };

  const vote = async function (value) {
    const comment = window.prompt(value === 1 ? 'Add a note with your support (optional)' : 'What is your concern? (optional)') || '';
    setBusy(true);
    try {
      const res = await fetch(API + '/mods/' + modId + '/vote/', {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({ value: value, comment: comment }),
      });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      load();
    } catch (e) { alert(e.message); }
    setBusy(false);
  };

  const v = d.mod.votes || { up: 0, down: 0, net: 0 };

  return (
    <div style={{ background: C.surface, borderRadius: 9, padding: 12, marginTop: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <span style={{ fontSize: 13.5, fontWeight: 700 }}>{d.mod.name} - introduction</span>
        <button onClick={onClose} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 15, color: C.muted }}>x</button>
      </div>

      {isMe ? (
        <>
          <textarea value={text} onChange={function (e) { setText(e.target.value); }} rows={5}
            placeholder="Tell the team about yourself - how long you have been in Pi, which channels you help in, what you are good at."
            style={{ ...inp, resize: 'vertical' }} />
          <button onClick={saveIntro} disabled={busy} style={btnMain}>
            {busy ? 'Saving...' : (d.mod.introduction ? 'Update' : 'Post introduction')}
          </button>
        </>
      ) : d.mod.introduction ? (
        <p style={{ fontSize: 12.5, color: C.text, whiteSpace: 'pre-wrap', lineHeight: 1.6, margin: '0 0 10px' }}>{d.mod.introduction}</p>
      ) : (
        <p style={{ fontSize: 12, color: C.muted, margin: '0 0 10px' }}>No introduction yet.</p>
      )}

      {d.mod.introduction && (
        <div style={{ borderTop: '1px solid ' + C.border, paddingTop: 9, marginTop: 9 }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: C.primary }}>Support {v.up}</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: C.danger }}>Concern {v.down}</span>
            {d.can_vote && (
              <span style={{ display: 'flex', gap: 6, marginLeft: 'auto' }}>
                <button onClick={function () { vote(1); }} disabled={busy}
                  style={{ ...btn, color: C.primary, borderColor: C.primary, fontWeight: d.my_vote && d.my_vote.value === 1 ? 700 : 400, background: d.my_vote && d.my_vote.value === 1 ? C.primaryBg : '#fff' }}>Support</button>
                <button onClick={function () { vote(-1); }} disabled={busy}
                  style={{ ...btn, color: C.danger, borderColor: C.danger, fontWeight: d.my_vote && d.my_vote.value === -1 ? 700 : 400 }}>Concern</button>
              </span>
            )}
          </div>
          {d.votes.length > 0 && (
            <div style={{ marginTop: 9 }}>
              {d.votes.map(function (x, i) {
                return (
                  <div key={i} style={{ fontSize: 11.5, color: C.muted, padding: '3px 0' }}>
                    <b style={{ color: x.value === 1 ? C.primary : C.danger }}>{x.value === 1 ? '+' : '!'}</b>{' '}
                    {x.voter}{x.comment ? ' - ' + x.comment : ''}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function HistoryPanel({ modId, onClose }) {
  const [d, setD] = useState(null);

  useEffect(function () {
    fetch(API + '/mods/' + modId + '/history/', { headers: authHeaders() })
      .then(function (r) { return r.json(); }).then(setD).catch(function () {});
  }, [modId]);

  if (!d) return <p style={{ fontSize: 12, color: C.muted, padding: '1rem 0' }}>Loading...</p>;
  if (d.error) return <p style={{ fontSize: 12, color: C.danger, padding: '1rem 0' }}>{d.error}</p>;

  const stat = function (label, value) {
    return (
      <div style={{ flex: '1 1 70px', textAlign: 'center' }}>
        <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: C.text }}>{value}</p>
        <p style={{ margin: 0, fontSize: 9.5, color: C.muted, textTransform: 'uppercase' }}>{label}</p>
      </div>
    );
  };

  return (
    <div style={{ background: C.surface, borderRadius: 9, padding: 12, marginTop: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
        <span style={{ fontSize: 13.5, fontWeight: 700 }}>{d.mod.name} - record</span>
        <button onClick={onClose} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 15, color: C.muted }}>x</button>
      </div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12, background: '#fff', borderRadius: 8, padding: '9px 6px' }}>
        {stat('activated', d.times_activated)}
        {stat('deactivated', d.times_deactivated)}
        {stat('roll calls', d.rollcalls_answered)}
        {stat('tasks done', d.tasks_done)}
        {stat('Q&A added', d.qa_added)}
      </div>
      <p style={{ fontSize: 12, fontWeight: 700, margin: '0 0 6px' }}>Status changes</p>
      {d.history.length === 0 ? (
        <p style={{ fontSize: 11.5, color: C.muted }}>Nothing yet.</p>
      ) : d.history.map(function (h, i) {
        return (
          <div key={i} style={{ fontSize: 11.5, color: C.muted, padding: '4px 0', borderBottom: '1px solid ' + C.border }}>
            <b style={{ color: C.text }}>{(h.from_status || 'new') + ' -> ' + h.to_status}</b>
            {h.from_level !== h.to_level && h.to_level ? ' - ' + h.from_level + ' to ' + h.to_level : ''}
            {' - by ' + h.by + ' - ' + when(h.at)}
            {h.reason ? <div style={{ fontSize: 11 }}>"{h.reason}"</div> : null}
          </div>
        );
      })}
    </div>
  );
}

export default function ModsTab({ me }) {
  const [d, setD] = useState(null);
  const [group, setGroup] = useState(false);
  const [status, setStatus] = useState('active');
  const [country, setCountry] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [openIntro, setOpenIntro] = useState(null);
  const [openHistory, setOpenHistory] = useState(null);
  const [form, setForm] = useState({ username: '', level: 'mod', display_name: '', country: '', country_code: '', city: '', channels: '', timezone: '', hours: '', languages: '' });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const load = useCallback(function () {
    const q = new URLSearchParams({ status: status });
    if (group) q.set('group', 'country');
    if (country) q.set('country', country);
    fetch(API + '/mods/?' + q, { headers: authHeaders() })
      .then(function (r) { return r.json(); }).then(setD).catch(function () {});
  }, [status, group, country]);
  useEffect(function () { load(); }, [load]);

  if (!d) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>Loading...</p>;
  if (d.error) return <p style={{ color: C.danger, textAlign: 'center', padding: '2rem 0' }}>{d.error}</p>;

  const addMod = async function () {
    if (!form.username.trim()) { setMsg('Enter their PenFlow username.'); return; }
    setBusy(true); setMsg('');
    try {
      const res = await fetch(API + '/mods/add/', { method: 'POST', headers: authHeaders(), body: JSON.stringify(form) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      setMsg('@' + form.username + ' added.');
      setForm({ username: '', level: 'mod', display_name: '', country: '', country_code: '', city: '', channels: '', timezone: '', hours: '', languages: '' });
      setShowAdd(false);
      load();
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  const act = async function (mod, action) {
    let reason = '';
    if (action === 'deactivate' || action === 'remove') {
      reason = window.prompt('Why are you marking ' + mod.name + ' as ' + action + 'd?') || '';
    } else if (action === 'promote') {
      if (!window.confirm('Make ' + mod.name + ' a Mega Mod?')) return;
    }
    try {
      const res = await fetch(API + '/mods/' + mod.id + '/', { method: 'POST', headers: authHeaders(), body: JSON.stringify({ action: action, reason: reason }) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      load();
    } catch (e) { alert(e.message); }
  };

  const ModCard = function ({ m }) {
    return (
      <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 9, padding: '10px 12px', marginBottom: 7 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 13.5, fontWeight: 600, display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
            <StatusDot status={m.status} />
            {m.country_code ? <Flag code={m.country_code} size={15} /> : null}
            {m.name}
            <LevelBadge level={m.level} />
          </span>
          <span style={{ fontSize: 10.5, color: C.muted }}>seen {ago(m.last_active)}</span>
        </div>
        <p style={{ margin: '3px 0 0', fontSize: 11.5, color: C.muted }}>
          @{m.username}
          {m.city || m.country ? ' - ' + [m.city, m.country].filter(Boolean).join(', ') : ''}
          {m.hours ? ' - ' + m.hours : ''}
          {m.timezone ? ' (' + m.timezone + ')' : ''}
        </p>
        {m.channels ? <p style={{ margin: '2px 0 0', fontSize: 11.5, color: C.muted }}>Channels: {m.channels}</p> : null}
        {m.languages ? <p style={{ margin: '2px 0 0', fontSize: 11, color: C.muted }}>Speaks: {m.languages}</p> : null}
        {m.added_by ? <p style={{ margin: '2px 0 0', fontSize: 10.5, color: C.muted }}>added by {m.added_by}</p> : null}
        {m.times_deactivated > 0 ? <p style={{ margin: '2px 0 0', fontSize: 10.5, color: C.gold }}>{m.times_activated}x active - {m.times_deactivated}x inactive</p> : null}

        <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginTop: 7 }}>
          <button style={btn} onClick={function () { setOpenIntro(openIntro === m.id ? null : m.id); setOpenHistory(null); }}>
            {m.has_intro ? 'Introduction' : 'No intro'}
          </button>
          {d.can_manage && (
            <>
              <button style={btn} onClick={function () { setOpenHistory(openHistory === m.id ? null : m.id); setOpenIntro(null); }}>Record</button>
              {m.status === 'active' ? (
                <button style={{ ...btn, color: C.gold, borderColor: C.gold }} onClick={function () { act(m, 'deactivate'); }}>Deactivate</button>
              ) : (
                <button style={{ ...btn, color: C.primary, borderColor: C.primary }} onClick={function () { act(m, 'activate'); }}>Activate</button>
              )}
              {d.is_admin && m.level === 'mod' ? <button style={{ ...btn, color: C.purple, borderColor: C.purple }} onClick={function () { act(m, 'promote'); }}>Make Mega</button> : null}
              {d.is_admin && m.level === 'mega' ? <button style={btn} onClick={function () { act(m, 'demote'); }}>Make Mod</button> : null}
            </>
          )}
        </div>
        {openIntro === m.id ? <IntroPanel modId={m.id} meProfile={me && me.profile} onClose={function () { setOpenIntro(null); }} /> : null}
        {openHistory === m.id ? <HistoryPanel modId={m.id} onClose={function () { setOpenHistory(null); }} /> : null}
      </div>
    );
  };

  return (
    <>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
        <button onClick={function () { setGroup(!group); }} style={{ ...btn, background: group ? C.primaryBg : '#fff', color: group ? C.primary : C.muted, fontWeight: group ? 700 : 400 }}>By country</button>
        <select value={status} onChange={function (e) { setStatus(e.target.value); }} style={{ ...btn, cursor: 'pointer' }}>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="removed">Removed</option>
          <option value="all">All</option>
        </select>
        {d.countries.length > 0 && (
          <select value={country} onChange={function (e) { setCountry(e.target.value); }} style={{ ...btn, cursor: 'pointer' }}>
            <option value="">All countries</option>
            {d.countries.map(function (c) { return <option key={c.country} value={c.country}>{c.country} ({c.count})</option>; })}
          </select>
        )}
        {d.can_manage ? <button onClick={function () { setShowAdd(!showAdd); }} style={{ ...btnMain, marginLeft: 'auto' }}>+ Add moderator</button> : null}
      </div>

      {showAdd && d.can_manage && (
        <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 9, padding: 12, marginBottom: 12 }}>
          <p style={{ margin: '0 0 3px', fontSize: 13.5, fontWeight: 700 }}>Add a moderator</p>
          <p style={{ margin: '0 0 9px', fontSize: 11, color: C.muted, lineHeight: 1.5 }}>They need a PenFlow account first - ask them to open PenFlow and sign in with Pi once.</p>
          <input value={form.username} onChange={function (e) { setForm({ ...form, username: e.target.value }); }} placeholder="Their Pi username (without @)" style={inp} />
          {d.is_admin && (
            <select value={form.level} onChange={function (e) { setForm({ ...form, level: e.target.value }); }} style={inp}>
              <option value="mod">Moderator</option>
              <option value="mega">Mega Mod</option>
            </select>
          )}
          <div style={{ display: 'flex', gap: 7 }}>
            <input value={form.country} onChange={function (e) { setForm({ ...form, country: e.target.value }); }} placeholder="Country" style={inp} />
            <input value={form.country_code} onChange={function (e) { setForm({ ...form, country_code: e.target.value }); }} placeholder="Code (PK)" maxLength={2} style={{ ...inp, width: 90 }} />
          </div>
          <div style={{ display: 'flex', gap: 7 }}>
            <input value={form.city} onChange={function (e) { setForm({ ...form, city: e.target.value }); }} placeholder="City" style={inp} />
            <input value={form.timezone} onChange={function (e) { setForm({ ...form, timezone: e.target.value }); }} placeholder="Timezone (PKT)" style={inp} />
          </div>
          <input value={form.channels} onChange={function (e) { setForm({ ...form, channels: e.target.value }); }} placeholder="Which channels do they moderate?" style={inp} />
          <div style={{ display: 'flex', gap: 7 }}>
            <input value={form.hours} onChange={function (e) { setForm({ ...form, hours: e.target.value }); }} placeholder="Usual hours (6pm - 11pm)" style={inp} />
            <input value={form.languages} onChange={function (e) { setForm({ ...form, languages: e.target.value }); }} placeholder="Languages" style={inp} />
          </div>
          {msg ? <p style={{ fontSize: 12, margin: '0 0 8px', color: msg.indexOf('added') >= 0 ? C.primary : C.danger }}>{msg}</p> : null}
          <div style={{ display: 'flex', gap: 7 }}>
            <button onClick={addMod} disabled={busy} style={btnMain}>{busy ? 'Adding...' : 'Add'}</button>
            <button onClick={function () { setShowAdd(false); setMsg(''); }} style={btn}>Cancel</button>
          </div>
        </div>
      )}

      {group && d.by_country ? (
        d.by_country.map(function (g) {
          return (
            <div key={g.country} style={{ marginBottom: 14 }}>
              <div style={{ background: C.surface, borderRadius: 8, padding: '7px 11px', marginBottom: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
                <span style={{ fontSize: 13, fontWeight: 700, display: 'flex', gap: 6, alignItems: 'center' }}>
                  {g.code ? <Flag code={g.code} size={16} /> : null} {g.country}
                </span>
                <span style={{ fontSize: 11, color: C.muted }}>
                  {g.total} {g.total === 1 ? 'mod' : 'mods'}
                  {g.megas > 0 ? ' - ' + g.megas + ' mega' : ''}
                  {g.cities.length > 0 ? ' - ' + g.cities.map(function (c) { return c.city + ' (' + c.count + ')'; }).join(', ') : ''}
                </span>
              </div>
              {g.mods.map(function (m) { return <ModCard key={m.id} m={m} />; })}
            </div>
          );
        })
      ) : d.mods.length === 0 ? (
        <p style={{ textAlign: 'center', color: C.muted, fontSize: 12.5, padding: '2rem 0' }}>No moderators here yet.</p>
      ) : d.mods.map(function (m) { return <ModCard key={m.id} m={m} />; })}
    </>
  );
}
